import React from 'react'
import tw from 'twin.macro'
import { Link } from 'gatsby'

import {
  HeaderStyle,
  CopyStyle,
  LinkButton,
  SubheadSMStyle,
  CopySMStyle,
} from './UI'
import { Disclosure } from '@headlessui/react'

import { GatsbyImage } from 'gatsby-plugin-image'

const Opps = ({ image, headline, subhead, careers }) => {
  return (
    <section tw="max-w-screen-xl mx-auto">
      <div tw="pb-14 flex flex-col lg:(py-14 grid grid-cols-[1fr repeat(12, calc(1024px/12)) 1fr])">
        {/* Image */}
        <div tw="mb-16 lg:(col-span-6 mb-0 px-0)">
          <GatsbyImage
            tw="w-full mb-4"
            image={image.gatsbyImageData}
            alt={image.filename}
          />
        </div>
        {/* Right side */}
        <div tw="mx-7 lg:(mx-0 col-start-8 col-span-6 flex items-start pt-2)">
          <div>
            <h2 css={[HeaderStyle, tw`mb-7 lg:(mb-[22px])`]}>{headline}</h2>
            <p css={[CopyStyle, tw`mb-[42px] lg:(mb-8 pr-10)`]}>{subhead}</p>
            {/* Cards */}
            {careers.map((career, index) => (
              <Disclosure
                key={`career-${index}`}
                as="div"
                tw="border border-[#202C3A] mb-4"
              >
                <Disclosure.Button css={[tw`p-7 w-full text-left`]}>
                  <div tw="w-full overflow-x-hidden">
                    <h3 css={[SubheadSMStyle, tw`block mb-1`]}>
                      {career.title}
                    </h3>
                    <div tw="flex items-center">
                      <span css={[CopySMStyle, tw`inline-block`]}>
                        {career.location}
                      </span>
                    </div>
                  </div>
                </Disclosure.Button>
                <Disclosure.Panel tw="pb-7 px-8">
                  <p css={[CopyStyle, tw`mb-9`]}>
                    {career.description.description}
                  </p>
                  <LinkButton external destination={career.jobPostingUrl}>
                    View and Apply
                  </LinkButton>
                </Disclosure.Panel>
              </Disclosure>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Opps
